SlideView = require("views/slide")

class TitleView extends SlideView
  template: require("./template")

  serialize: ->
    data = super
    data.continueBtnText = i18n("buttons.close-lesson")
    data.hasPrompt = not data.exitButton # show either exit button or prompt (which is apparently empty)
    data

  events: ->
    "click .btn-next": "next"
    "click .btn-done": "exit"

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

module.exports = TitleView